import angular from "angular";

angular
    .module('app')
    .component('courseGroupForm', {
        template: require('./course-group-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope, moment) {

    let $ctrl = this;

    $ctrl.course = null;
    $ctrl.id = null;
    $ctrl.startDate = null;
    $ctrl.cost = 0;
    $ctrl.discountValue = 0;
    $ctrl.onlinePayment = true;
    $ctrl.offlinePayment = false;
    $ctrl.paymentInfo = null;
    $ctrl.status = null;


    $ctrl.$onInit = function () {
        $ctrl.step = 1;
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.chapters = $ctrl.resolve.chapters;
        $ctrl.chapters.forEach(function (chapter) {
            chapter.lessons.forEach(function (lesson) {
                lesson.can_open = true;
                lesson.can_open_delay = 0;
                lesson.homework_required = false;
                lesson.quiz_required = false;
            })
        });

        if ($ctrl.resolve.group) {
            let gr = $ctrl.resolve.group;
            $ctrl.course = gr.course;
            $ctrl.id = gr.id;
            $ctrl.cost = gr.cost;
            $ctrl.discountValue = gr.discount_value;
            $ctrl.onlinePayment = gr.online_payment;
            $ctrl.offlinePayment = gr.offline_payment;
            $ctrl.paymentInfo = gr.payment_info;
            $ctrl.startDate = moment(gr.start_date).toDate();
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let startDate = moment($ctrl.startDate).format('YYYY-MM-DD');

        let params = {
            course_id: $ctrl.course.id,
            start_date: startDate,
            cost: $ctrl.cost,
            discount_value: $ctrl.discountValue,
            online_payment: $ctrl.onlinePayment,
            offline_payment: $ctrl.offlinePayment,
            payment_info: $ctrl.paymentInfo,
            status: $ctrl.status,
            chapters: $ctrl.chapters,
        };

        let req = null;

        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.id}`, params);
        } else {
            req = $http.post(`/admin/courses/${$ctrl.course.id}/groups`, params);
        }

        req.then(
            function (response) {
                $ctrl.loading = false;

                if (!$ctrl.id) {
                    params.id = response.data.id;
                    params.number = response.data.number;
                    params.course = $ctrl.course;
                    params.status = response.data.status;
                    Notifier.success('Группа успешно создана', 2);
                } else {
                    Notifier.success('Данные успешно обновлены', 2);
                }
                $ctrl.close({$value: params});
            },
            function (error) {
                $ctrl.loading = false;
                ErrorResponseParser.parse(error);
            }
        );
    };

    $ctrl.nextStep = function () {
        $ctrl.step++;
    };

    $ctrl.previousStep = function () {
        $ctrl.step--;
    };

}
